import React from 'react';
import PropTypes from 'prop-types';
import WarningIcon from '@mui/icons-material/Warning';
import PublishIcon from '@mui/icons-material/Publish';
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal';
import { TitleContainer, IconContainer, TitleText } from './PublishConfirmationModal.styles';

const PublishConfirmationModal = ({ open, onPublish, onClose, hasUnassignedShifts }) => {
  const title = hasUnassignedShifts ? 'This schedule has unassigned shifts. Continue?' : 'Publish this schedule?';

  const icon = hasUnassignedShifts ? <WarningIcon /> : <PublishIcon />;
  const iconColor = hasUnassignedShifts ? '#ff9800' : '#1976d2';

  return (
    <ConfirmationModal
      open={open}
      onConfirm={onPublish}
      onClose={onClose}
      title={
        <TitleContainer>
          <IconContainer iconColor={iconColor}>{icon}</IconContainer>
          <TitleText variant="h6" component="h2">
            {title}
          </TitleText>
        </TitleContainer>
      }
      confirmButtonText="Publish"
    />
  );
};

PublishConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onPublish: PropTypes.func.isRequired,
  hasUnassignedShifts: PropTypes.bool.isRequired,
};

export default PublishConfirmationModal;
